import { normalizeFields } from "@/forms/helpers";

export function createFormFields(source: {
  specialization: Record<string, string>;
}) {
  const { specialization } = source;

  return normalizeFields({
    city: {
      type: "text",
      label: "Miasto",
      value: "",
      required: true,
    },
    facilityName: {
      type: "text",
      label: "Nazwa Twojej placówki",
      value: "",
      required: true,
      min: 6,
    },
    unitName: {
      type: "text",
      label: "Nazwa Twojego oddziału",
      value: "",
      required: true,
      min: 6,
    },
    specialization: {
      type: "select",
      label: "Specjalizacja",
      placeholder: "Wybierz specjalizację",
      options: Object.entries(specialization)
        .sort()
        .map(([name, value]) => ({ value, name })),
      selected: null,
      required: true,
    },
  });
}
